/* adblock bing tracking fix */
window.UET = (p) => {
    this.push = (p) => {};
};
